import { Button } from "antd";
import React from "react";

const ButtonComponent = ({
  label,
  type,
  className,
  onClick,
  size,
  icon,
  htmlType,
  loading,
  shape,
  style,
  // loading,
  disabled,
  rightIcon,
  danger,
}) => {
  return (
    <Button
      type={type}
      className={className}
      icon={icon}
      onClick={onClick}
      size={size}
      htmlType={htmlType}
      shape={shape}
      style={style}
      // loading={loading}
      disabled={disabled}
      danger={danger}
    >
      {label}
      {rightIcon}
    </Button>
  );
};
export default ButtonComponent;
